// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityMetadataBar_container__SwGRY","title":"ActivityMetadataBar_title__287QK"};